import React, { useState, useEffect, useMemo } from "react";
import "./index.css";
import TextField from "../../../../../../../components/inputs/textfield";
import { userAreaList } from "../../../../../user.api";
import Snackbar from "../../../../../../../components/snackbar/snackbar";

export default function BuilUpFormOptionTable(props) {
  const {
    formvalues: initialFormValues = [],
    data = [],
    formData: incomingFormData = {},
    initialFormData = {},
    handleFormData,
  } = props;
  const [isActive, setIsActive] = useState(false);

  const [formvalues, setFormValues] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);


  useEffect(() => {
    if (isLoaded) return;

    if (initialFormValues && initialFormValues.length > 0) {
      // Ensure each item has a category for conditional rendering
      const mapped = initialFormValues.map((item) => ({
        ...item,
        category: item.category || "built-up",
        area_management_id: item.area_management_id || 1,
        built_space_type_name: item.built_space_type_name || item.built_space_type || "",
        location_id: item.location_id ? String(item.location_id) : "",
      }));
      setFormValues(mapped);
      setIsLoaded(true);
      setTimeout(() => {
        handleFormData(mapped);
      }, 100);
    } else {
      const defaultValues = [
        {
          category: "built-up",
          location_id: "",
          sub_location: "",
          area_in_acres: "",
          rupees_in_lakhs_or_acres: "",
          built_space_type_name: "",
          area_in_sqft: "",
          investment_model: "",
          management_plan: "",
          land_address: "",
        },
      ];
      setFormValues(defaultValues);
      setIsLoaded(true);
      setTimeout(() => {
        handleFormData(defaultValues);
      }, 100);
    }
  }, [initialFormValues, isLoaded, handleFormData]);

  const [baseArea, setBaseArea] = useState([]);
  const [areaErrors, setAreaErrors] = useState({});
  const [formData, setFormData] = useState({
    ...initialFormData,
  });
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);

  const snackbarClose = () => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };

  const handleAreaTextChange = (e, index) => {
    const { name, value } = e.target;
    const validNumber = /^\d*\.?\d*$/;

    // Validate number format
    if (!validNumber.test(value)) return;

    const updated = [...formvalues];
    const currentMatchedArea = matchedArea(index);
    const maxArea = Number(currentMatchedArea?.available_area || 0);

    // Convert value to number
    const inputValue = Number(value);

    // If exceeds available, show snackbar and clear the field (same as land form)
    if (inputValue > maxArea) {
      setSnackMessage(
        `Sorry, we have only ${maxArea} Sq.ft available at this location. Kindly choose an alternate location or reduce your requirement or please contact : info@kspace.org.in`
      );
      setIsSnackError(true);
      setSnackOpen(true);
      // Clear any previous inline error
      setAreaErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[index];
        return newErrors;
      });
      // Clear the current input value
      updated[index] = {
        ...updated[index],
        [name]: "",
      };
      setFormValues(updated);
      handleFormData(updated);
      return;
    } else {
      // Clear any previous error
      setAreaErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[index];
        return newErrors;
      });
    }

    updated[index] = {
      ...updated[index],
      [name]: value,
    };

    setFormValues(updated);
    handleFormData(updated);
  };

  const getUserAreaList = () => {
    setIsActive(true);
    userAreaList().then((res) => {
      const filtered = (res?.data || []).filter(
        (item) => item?.areasubs?.area_type_caption === "built-up"
      );
      setBaseArea(filtered);
      setIsActive(false);
    });
  };

  useEffect(() => {
    getUserAreaList();
  }, []);

  const handleAdd = () => {
    if (formvalues.length < 3) {
      setFormValues([
        ...formvalues,
        {
          location_id: "",
          sub_location: "",
          category: "built-up",
          area_management_id: 1,
          area_in_acres: "",
          rupees_in_lakhs_or_acres: "",
          built_space_type_name: "",
          area_in_sqft: "",
          investment_model: "",
          management_plan: "",
          land_address: "",
        },
      ]);
    }
  };

  const handleRemove = (index) => {
    const updated = formvalues.filter((_, i) => i !== index);
    setFormValues(updated);
  };

  const handleCategoryChange = (e, index) => {
    const selectedCategory = e.target.value;
    let areaManagementId = null;

    if (selectedCategory === "built-up") {
      areaManagementId = 1;
    } else if (selectedCategory === "land") {
      areaManagementId = 3;
    }

    const updated = [...formvalues];
    updated[index] = {
      ...updated[index],
      category: selectedCategory,
      area_management_id: areaManagementId,
      sub_location: "",
      built_space_type_name: "",
    };

    setFormValues(updated);
    setTimeout(() => {
      handleFormData(updated);
    }, 100);
  };

  const getSubLocations = (locationId, areaManagementId) => {
    const fallbackCategoryId = 1;
    return baseArea
      .filter(
        (item) =>
          String(item.location_id) === String(locationId) &&
          String(item.area_management_id) === String(areaManagementId || fallbackCategoryId)
      )
      .map((item) => item.sub_location)
      .filter(Boolean);
  };

  const handleLocationChange = (e, index) => {
    const locationId = e.target.value;
    const updated = [...formvalues];

    updated[index] = {
      ...updated[index],
      [e.target.name]: locationId,
      sub_location: "",
      built_space_type_name: "",
      location:
        baseArea.find((a) => String(a.location_id) === String(locationId))?.locations
          ?.locations || "",
    };

    setFormValues(updated);
    setTimeout(() => {
      handleFormData(updated);
    }, 100);
  };

  const handleSubLocationChange = (e, index) => {
    const subLoc = e.target.value;
    const updated = [...formvalues];

    updated[index] = {
      ...updated[index],
      [e.target.name]: subLoc,
      built_space_type_name: "",
    };

    setFormValues(updated);
    setTimeout(() => {
      handleFormData(updated);
    }, 100);
  };

  const handleBuiltTypeChange = (e, index) => {
    const { name, value } = e.target;
    const updated = [...formvalues];

    updated[index] = {
      ...updated[index],
      [name]: value,
    };

    setFormValues(updated);
    setTimeout(() => {
      handleFormData(updated);
    }, 100);
  };

  const filteredAreaTypes = (index) => {
    const item = formvalues[index];
    if (!item?.location_id || !item?.sub_location) return [];

    const filtered = baseArea.filter(
      (area) =>
        String(area.location_id) === String(item.location_id) &&
        area.sub_location === item.sub_location &&
        area.built_space_type?.name
    );

    return Array.from(
      new Set(filtered.map((area) => area.built_space_type.name))
    );
  };

  const matchedArea = (index) => {
    const item = formvalues[index];
    return baseArea.find((area) => {
      const matchLocation =
        String(area.location_id) === String(item.location_id);
      const matchSubLocation = area.sub_location === item.sub_location;
      const matchCategory = area.areasubs?.type === item.category;

      const matchBuiltType =
        item.category === "built-up"
          ? area.built_space_type?.name === item.built_space_type_name
          : true;

      return (
        matchLocation && matchSubLocation && matchCategory && matchBuiltType
      );
    });
  };

  const matchedLandArea = (index) => {
    const item = formvalues[index];
    if (!item?.location_id || !item?.sub_location || !item?.category)
      return null;

    return baseArea.find(
      (area) =>
        String(area.location_id) === String(item.location_id) &&
        area.sub_location === item.sub_location &&
        String(area.area_management_id) === String(item.area_management_id)
    );
  };

  const handleTextChange = (e, index) => {
    const { name, value } = e.target;
    const validNumber = /^\d*\.?\d*$/;

    if (validNumber.test(value)) {
      const updated = [...formvalues];
      updated[index] = {
        ...updated[index],
        [name]: value,
      };
      setFormValues(updated);
      setTimeout(() => {
        handleFormData(updated);
      }, 100);
    }
  };

  const handleChangeText = (e, index) => {
    const { name, value } = e.target;

    const updated = [...formvalues];
    updated[index] = {
      ...updated[index],
      [name]: value,
    };

    setFormValues(updated);

    setTimeout(() => {
      handleFormData(updated);
    }, 100);
  };
  const uniqueLocations = Array.from(
    new Map(
      baseArea?.map((area) => [area?.locations?.locations, area])
    ).values()
  );

  return (
    <div>
      <div>Provide your space requirement on priority (Maximum 3 locations)</div>
      {formvalues.map((item, index) => {
        const currentSubLocations = getSubLocations(
          item.location_id,
          item.area_management_id
        );
        const currentMatchedArea = matchedArea(index);
        const currentMatchedLandArea = matchedLandArea(index);
        const currentAreaTypes = filteredAreaTypes(index);

        return (
          <div
            key={index}
            className="mb-3"
            style={{
              border: "1px solid #e0e0e0",
              borderRadius: 8,
              padding: 16,
              boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
              background: "#fff",
              position: "relative",
            }}
          >
            {formvalues.length > 1 && (
              <button
                type="button"
                aria-label="Remove preference"
                onClick={() => handleRemove(index)}
                style={{
                  position: "absolute",
                  top: 12,
                  right: 12,
                  background: "#000",
                  border: "none",
                  color: "#fff",
                  fontSize: 16,
                  cursor: "pointer",
                  borderRadius: 5,
                  width: 24,
                  height: 24,
                }}
                title="Remove"
              >
                X
              </button>
            )}
            <div
              className="d-flex align-items-center justify-content-between mb-3"
              style={{ borderBottom: "1px dashed #ddd", paddingBottom: 8 }}
            >
              <div style={{ fontWeight: 600 }}>
                Preference {index + 1}
              </div>
            </div>

            <div className="row">
              <div className="col-6  ">
                <div className="fieldset">
                  <label className="mb-1">Location</label>
                  <select
                    className="form-select mandatory-select"
                    required
                    name="location_id"
                    onChange={(e) => handleLocationChange(e, index)}
                    value={item.location_id || ""}
                  >
                    <option value="">Location</option>
                    {uniqueLocations?.map((area) => (
                      <option key={area?.id} value={area?.location_id}>
                        {area?.locations?.locations}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-6  ">
                <div className="fieldset">
                  <label className="mb-1">Sub Location</label>
                  <select
                    className="form-select mandatory-select"
                    required
                    name="sub_location"
                    onChange={(e) => handleSubLocationChange(e, index)}
                    value={item.sub_location || ""}
                  >
                    <option value="">Select Sub Location</option>
                    {Array.from(
                      new Map(
                        (currentSubLocations || []).map((s) => [
                          String(s).trim().toLowerCase(),
                          s,
                        ])
                      ).values()
                    ).map((subLoc, i) => (
                      <option key={i} value={subLoc}>
                        {subLoc}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-6  ">
                <div className="fieldset">
                  <label className="mb-1">Category</label>
                  <select
                    className="form-select mandatory-select"
                    required
                    name="category"
                    value={item.category || "built-up"}
                    disabled
                  >
                    <option value="built-up">Built-up Space</option>
                  </select>
                </div>
              </div>



              {item.category === "land" && (
                <div className="col-6  ">
                  <TextField
                    label="Available Area in Cent"
                    name="available_area"
                    type="text"
                    value={currentMatchedLandArea?.available_area || ""}
                    onChange={(e) => handleTextChange(e, index)}
                    disabled
                    required
                  />
                </div>
              )}

              {item.category === "land" && (
                <div className="col-6  ">
                  <TextField
                    label="Base premium /cent (rupees)"
                    name="rupees_in_lakhs_or_acres"
                    type="text"
                    value={item.rupees_in_lakhs_or_acres || ""}
                    onChange={(e) => handleTextChange(e, index)}
                    required
                  />
                </div>
              )}

              {item.category === "built-up" && (
                <div className="col-6  ">
                  <div className="fieldset">
                    <label className="mb-1">Area Type</label>
                    <select
                      className="form-select mandatory-select"
                      name="built_space_type_name"
                      value={item.built_space_type_name || ""}
                      onChange={(e) => handleBuiltTypeChange(e, index)}
                      required
                    >
                      <option value="">Select Area Type</option>
                      {currentAreaTypes.map((typeName, idx) => (
                        <option key={idx} value={typeName}>
                          {typeName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              {item.category === "built-up" && (
                <div className="d-flex">
                  <div className="col-6 " style={{ paddingRight: "12px" }}>
                    <TextField
                      label="Total available area (in Sq.ft)"
                      name="available_area"
                      type="text"
                      value={currentMatchedArea?.available_area || ""}
                      disabled
                      required
                    />
                  </div>
                  <div className="col-6 " style={{ paddingLeft: "12px" }}>
                    <TextField
                      label="Area Requirement (in Sq.ft)"
                      name="area_in_sqft"
                      type="text"
                      value={item.area_in_sqft || ""}
                      onChange={(e) => handleAreaTextChange(e, index)}
                      required
                      error={!!areaErrors[index]}
                      helperText={areaErrors[index] || " "} // The " " ensures consistent spacing
                      FormHelperTextProps={{
                        style: {
                          color: areaErrors[index]
                            ? "#f44336"
                            : "rgba(0, 0, 0, 0.6)",
                          margin: 0,
                          fontSize: "0.75rem",
                        },
                      }}
                    />
                  </div>
                </div>
              )}
              {/* {item.category === "built-up" && (
                <div className="col-6 mt-3">
                  <TextField
                    label="Base Renting Rate(Rupees / Sq.ft)"
                    name="rupees_in_sqft"
                    type="text"
                    value={currentMatchedArea?.rupees_in_sqft || ""}
                    disabled
                    required
                  />
                </div>
              )} */}
              {/* <div className="d-flex">
                <div className="col-6  " style={{ paddingRight: "12px" }}>
                  <TextField
                    label="Investment model"
                    name="investment_model"
                    type="text"
                    multiline
                    value={item.investment_model || ""}
                    onChange={(e) => handleChangeText(e, index)}
                  />
                </div>
                <div className="col-6  " style={{ paddingLeft: "12px" }}>
                  <TextField
                    label="Management plan"
                    name="management_plan"
                    type="text"
                    multiline
                    value={item.management_plan || ""}
                    onChange={(e) => handleChangeText(e, index)}
                  />
                </div>
              </div> */}
              {/* <div className="d-flex">
                <div className="col-6  " style={{ paddingRight: "12px" }}>
                  <TextField
                    label="Address of the property"
                    name="land_address"
                    type="text"
                    multiline
                    value={item.land_address || ""}
                    onChange={(e) => handleChangeText(e, index)}
                  />
                </div>
              </div> */}
              {/* Remove control moved to top-right as × button */}
            </div>
          </div>
        );
      })}
      {formvalues.length < 3 && (
        <button type="button" onClick={handleAdd} className="btn btn-primary ">
          Next Preference
        </button>
      )}
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
    </div>
  );
}
